import React from "react";
import {
  FaRocket,
  FaPiggyBank,
  FaPlug,
  FaClipboardCheck,
} from "react-icons/fa";

function Elevate() {
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Features</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Benefits of our White Label Exchange
                </h2>
                <p>
                  Our white label crypto exchange offers astonishing advantages
                  that help to launch a crypto exchange in a quick way. Just
                  enter details in the admin panel, set your branding & it's
                  ready to serve millions of users!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="fade-up-anim">
            <div className="row">
              <div className="col-xl-12">
                <div className="feature-style-four-items fade-up-anim">
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaRocket size={40} />
                      </div>
                      <h4>Quick Deployment</h4>
                      <p>
                        Launching is much faster compared to building it from
                        scratch.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaPiggyBank size={40} />
                      </div>
                      <h4>Low Development Costs</h4>
                      <p>
                        Avoiding significant development cost with a ready-made
                        platform.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaPlug size={40} />
                      </div>
                      <h4>Pre-Integrated Features</h4>
                      <p>
                        Comes with pre-integrated features that are essential
                        for an exchange.
                      </p>
                    </div>
                  </div>
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaClipboardCheck size={40} />
                      </div>
                      <h4>Compliance Tools</h4>
                      <p>
                        Often includes KYC/AML procedures and regulatory
                        compliance support.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Elevate;
